import React from 'react';
import toNumber from 'lodash/toNumber';
import get from 'lodash/get';

export default function getHeaderHeight() {
  if (!this) return null;

  const { device } = this.state;
  const heightHeader = toNumber(this.sensor.getVariable('heightHeaderPx'));
  const heightHeaderTablet = toNumber(this.sensor.getVariable('heightHeaderTabletPx'));
  const heightHeaderPhone = toNumber(this.sensor.getVariable('heightHeaderPhonePx'));
  const offsetConfig = {
    desktop: heightHeader,
    tablet: heightHeaderTablet,
    phone: heightHeaderPhone
  };

  return get(offsetConfig, `[${device}]`);
}
